import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Hero from '@/components/Hero.vue'
import Manifesto from '@/components/Manifesto.vue'
import HackathonAwards from '@/components/HackathonAwards.vue'
import People from '@/components/People.vue'
import SponsorsAndPartners from '@/components/SponsorsAndPartners.vue'
import FAQ from '@/components/FAQ.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MainPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Hero),
    _createVNode(Manifesto),
    _createVNode(HackathonAwards),
    _createVNode(People),
    _createVNode(SponsorsAndPartners),
    _createVNode(FAQ)
  ], 64))
}
}

})